import React from 'react';

import { pages, } from 'styles';

type Props = {
    imgPath: string,
};

export const SummaryOrderAcceptanceDetailsListItem: React.FC<Props> = ({
    children,
    imgPath,
}) => {
    const { item, } = pages.checkout.makeSummaryDetailsList({ imgPath, });

    return (
        <li className={item}>{children}</li>
    )
};

export default SummaryOrderAcceptanceDetailsListItem;
